import * as React from 'react'

import {Alert, Button, Form, message} from 'antd';
import {FormComponentProps} from "antd/lib/form";
import {observer} from "mobx-react";
import {ViewBaseComponent} from "../../../src/views/ViewComponentBase";
import commonStyles from '../../../src/styles/common.scss';
import {BASE_PATH} from "../../../src/swagger";
import appStyles from '../../assets/css/app.scss';
import {observable, runInAction} from "mobx";
import portableFetch from "portable-fetch";
import {getQueryParam} from "../../../src/utils/react/routerUtil";
import KixGbcMemberSimpleLayout from "../../layouts/KixGbcMemberSimpleLayout/KixGbcMemberSimpleLayout";
import {redirect} from "../../../src/common/Router/routerCommon";
import {loginUserStore} from "../../store/Login/LoginUserStore";

const FormItem = Form.Item;

@observer
class PasswordResetExec extends ViewBaseComponent<{} & FormComponentProps, {}> {
  formUtils = this.props.form;

  @observable
  sended = false;

  @observable
  error = "";

  @observable
  loading = false;

  private isRequested = false;

  componentWillMount() {
    // 二重呼び出し防止
    if (this.isRequested) {
      return;
    }
    this.isRequested = true;
    this.loading = true;

    let bodyObj = {
      reset_token: getQueryParam("token") as string,
    };
    const method = "POST";
    const body = JSON.stringify(bodyObj);
    const headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    };
    portableFetch(BASE_PATH + "/kix_gbc/first_account_setting_exec", {
      method,
      headers,
      body,
      credentials: "include"
    }).then(async (res: any) => {
      let json = await res.json();
      runInAction(() => {
        this.loading = false;
        if (json.result.code == 1) {
          loginUserStore.loginUserInfo = {};
          this.sended = true;
        } else {
          this.error = json.result.message;
        }
      });
    }).catch(() => {
      runInAction(() => {
        this.loading = false;
      });
      message.error("通信に失敗しました。もう一度お試し下さい。");
    });
  }

  componentWillUnmount() {
  }

  render() {
    // const {getFieldDecorator} = this.props.form;

    return (
      <><KixGbcMemberSimpleLayout notLogout={true}>
        <h2 className={appStyles.h2blue} style={{marginTop: "2em", marginBottom: "2em"}}>登録確認</h2>

        {!this.sended ?
          <>
            {this.error
            && <Alert style={{marginBottom: 24}} message={this.error} type="error" showIcon/>
            }
          </> : <>
            <p style={{color: "white", fontWeight: "bold"}}>
              アカウント初期設定が完了しました。
            </p>

            <div className={commonStyles.fCenter + " " + commonStyles.mt30}>
              <FormItem>
                <Button style={{padding: "0.5em 6em 0.5em 6em", margin: "1em 0 1em 0"}} type="primary"
                        size="large" className={appStyles.buttonBlue}
                        onClick={() => redirect("/")}
                >
                  戻る
                </Button>
              </FormItem>
            </div>
          </>
        }
      </KixGbcMemberSimpleLayout>
      </>
    );
  }
}

export default Form.create()(PasswordResetExec)

